<template>
  <v-container fluid name="nombreneLettres">
    <tr class=nel>
      <td>{{nombreEnLettres.mille}} </td>
      <td>{{nombreEnLettres.cent}}{{nombreEnLettres.s?'s ':' '}}</td>
      <td>{{nombreEnLettres.dix}} </td>
      <td>{{nombreEnLettres.un}}</td>
    </tr>
  </v-container>
</template>
<script>

  export default {
    name: "NombreEnLettres",
    components: {
    },
    computed: {
      nombreEnLettres: {
        get() {
            return this.en_lettre(this.parsedNumber);
        },
      },

    },
    props: {
      parsedNumber:Array,
    },
    data () {
      return {
        milliers:0,
        centaines:0,
        dizaines:0,
        unites:0,
      }
    },
    methods: {
      en_lettre(u) {
        this.milliers = parseInt(u[0]);
        this.centaines = parseInt(u[1]);
        this.dizaines = parseInt(u[2]);
        this.unites = parseInt(u[3]);
        let unite = ["", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf"];
        let dizaines = ["", "dix", "vingt", "trente", "quarante", "cinquante", "soixante", "soixante-dix", "quatre-vingt", "quatre-vingt-dix"];
        let vingtaine = ["dix", "onze", "douze", "treize", "quatorze", "quinze", "seize"];
        let chiffre_mille,chiffre_centaine,s,sp,chiffre_dizaine,chiffre_unite
        if (this.milliers) { //s'il y a des milliers
            if (this.milliers == 1) {
                chiffre_mille = "mille";
            } else {
                chiffre_mille = unite[this.milliers] + " mille ";
            }
        }

        if (this.centaines) { //s'il y a des centaines 
            if (this.centaines == 1) {
                chiffre_centaine = "cent";
            } else {
                chiffre_centaine = unite[this.centaines] + " cent";
                s = 1;
            }
        }

        sp = 1;
        if (this.dizaines) {
            chiffre_dizaine = dizaines[this.dizaines];
            if ((chiffre_dizaine == "dix" || chiffre_dizaine == "quatre-vingt-dix" || chiffre_dizaine == "soixante-dix") && this.unites < 7) {  //onze à seize
                if (this.unites == 1 && this.dizaines == 7) {
                    chiffre_dizaine = str_replace("-dix", "", chiffre_dizaine) + " et " + vingtaine[this.unites];
                } else {
                    chiffre_dizaine = str_replace("dix", "", chiffre_dizaine) + vingtaine[this.unites];
                }
                sp = 2;
            }
        }

        if (this.unites && sp == 1) { //s'il y a des unités et pas de contraction de dizaine.
            chiffre_unite = unite[this.unites];
            if (this.unites == 1 && chiffre_dizaine && this.dizaines < 7) {
                chiffre_dizaine += " et";
            } else if (chiffre_unite && chiffre_dizaine) {
                chiffre_dizaine += "-";
            }
        } else if (chiffre_dizaine == "quatre-vingt") {
            chiffre_dizaine = "quatre-vingts";
        }
        return ({"mille":chiffre_mille, "cent":chiffre_centaine, "dix":chiffre_dizaine, "un": chiffre_unite, "sp" : sp, "s" :s});
    }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
tr.nel td{
  padding: 2px;
}
</style>
